import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-16 px-4 bg-black text-white border-y-8 border-red-600" data-id="element-153">
      <div className="max-w-3xl mx-auto" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8 text-lg md:text-xl" data-id="element-155">
          <div className="text-center mb-12" data-id="element-156">
            <h2 className="text-3xl md:text-4xl font-black text-yellow-400 mb-6" data-id="element-157">
              Si sos mamá o papá, dejame hacerte una pregunta honesta
            </h2>
            <p className="font-bold text-2xl leading-relaxed" data-id="element-158">
              ¿Sentís que querés pasar más tiempo con tus hijos…
              <br data-id="element-159" />
              <span className="text-red-400" data-id="element-160">
                pero cuando llega el momento no sabés qué hacer juntos?
              </span>
            </p>
          </div>

          <div className="space-y-4 text-gray-300 max-w-2xl mx-auto" data-id="element-161">
            <p data-id="element-162">No porque no los ames.</p>
            <p data-id="element-163">No porque no quieras estar.</p>
            <p className="font-bold text-white" data-id="element-164">
              Sino porque la rutina, el cansancio y las pantallas lo ocupan
              todo.
            </p>
            <p data-id="element-165">Y cuando te das cuenta…</p>
            <p className="font-bold text-red-400 text-2xl" data-id="element-166">el día terminó.</p>
          </div>

          <div className="bg-gray-900 p-8 rounded-xl border border-gray-700 mt-12 shadow-2xl" data-id="element-167">
            <h3 className="text-2xl font-black text-white mb-6 border-b border-gray-700 pb-4" data-id="element-168">
              El problema que nadie dice en voz alta
            </h3>
            <div className="space-y-4 text-gray-300" data-id="element-169">
              <p data-id="element-170">
                Muchos padres comparten tiempo…{' '}
                <span className="text-yellow-400 font-bold" data-id="element-171">
                  pero no conexión real.
                </span>
              </p>
              <p data-id="element-172">Cada uno está con su celular.</p>
              <p data-id="element-173">
                Querés hacer algo especial con tus hijos, pero no sabés qué
                proponer.
              </p>
              <p data-id="element-174">Los días pasan rápido.</p>
              <p data-id="element-175">Los hijos crecen.</p>
              <p className="italic text-xl text-white font-medium border-l-4 border-red-500 pl-4 my-6" data-id="element-176">
                "Podría estar haciendo más… si tuviera una forma simple de
                hacerlo."
              </p>
            </div>
          </div>

          <div className="text-center mt-12 space-y-4" data-id="element-177">
            <p className="text-2xl font-bold text-white" data-id="element-178">
              No es falta de amor.
            </p>
            <p className="text-2xl font-bold text-yellow-400" data-id="element-179">
              Es falta de ideas.
            </p>

            <div className="text-left max-w-xl mx-auto mt-8 space-y-4 text-gray-300" data-id="element-180">
              <p data-id="element-181">
                Los padres quieren conectar con sus hijos. Pero muchas veces:
              </p>
              <ul className="space-y-2 font-medium text-white" data-id="element-182">
                <li className="flex items-center gap-2" data-id="element-183">
                  ❌ no saben qué actividades hacer
                </li>
                <li className="flex items-center gap-2" data-id="element-184">
                  ❌ no tienen tiempo para planificar
                </li>
                <li className="flex items-center gap-2" data-id="element-185">
                  ❌ no quieren pasar horas organizando
                </li>
              </ul>
              <p className="text-xl font-bold text-red-400 mt-6 text-center" data-id="element-186">
                Y por eso termina ganando la pantalla.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}